import { DatePipe } from '@angular/common';
import { Component, OnInit, signal, effect } from '@angular/core';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { FacturacionService } from '@facturacion/facturacion.service';
import { ModalRefacturacionComponent } from '@facturacion/shared/components/modal-refacturacion/modal-refacturacion.component';
import { NgbCalendar, NgbDatepickerConfig, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TipoReporteRefacturacion } from '@shared/enums/TipoReporteRefacturacion';
import { ReporteRefacturacionDTO } from '@shared/models/facturacion';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from "@shared/shared.service";

@Component({
  selector: 'app-refacturacion-devolucion-litros',
  templateUrl: './refacturacion-devolucion-litros.component.html',
  styleUrl: './refacturacion-devolucion-litros.component.scss'
})
export class RefacturacionDevolucionLitrosComponent implements OnInit {

  busquedaFormControl = new FormControl();
  fechaFormControlDesdeHasta = new UntypedFormControl();

  modelDesde: NgbDateStruct;
  modelHasta: NgbDateStruct;

  startDate: Date = new Date();
  endDate: Date = new Date();
  facturas: ReporteRefacturacionDTO[]=[];
  facturasFiltrados: ReporteRefacturacionDTO[]=[];
  loading = signal(false);
  buscando: boolean = false;

  constructor(
    private facturacionService: FacturacionService,
    private datePipe: DatePipe,
    private datepickerConfig2: NgbDatepickerConfig,
    private calendar: NgbCalendar,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private sharedService: SharedService,
    private comprobanteService: ComprobanteService
  ) {
    effect(() => this.loading ? this.spinner.show("spinnerGrafico") : this.spinner.hide("spinnerGrafico"))
  }

  ngOnInit(): void {
    this.loading.set(true);
    this.startDate.setHours(0, 0, 0, 0);
    this.modelDesde = this.calendar.getToday();
    this.modelHasta = this.calendar.getToday();
    const inicio: any = { day: 1, month: 1, year: 2019 };
    this.datepickerConfig2.minDate = inicio;
    const fin: any = { day: this.modelDesde.day, month: this.modelDesde.month, year: this.modelDesde.year };
    this.modelHasta = this.calendar.getToday();
    this.datepickerConfig2.maxDate = fin;
    this.getFacturasDevolucionLitros(this.startDate, this.endDate);
  }

  filtrarFacturas() {
    this.facturasFiltrados = this.facturas.filter(a => {
      let agregar = true;
      if (this.busqueda.value) {
        agregar = a.cliente.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1;

        agregar = agregar || (this.facturacionService.formatearComprobante(a.prefijoComprobante, a.numeroComprobante).indexOf(this.busqueda.value) > -1);

        agregar = agregar || (this.datePipe.transform(a.fechaHoraComprobante, "d/MM/y").indexOf(this.busqueda.value) > -1);
      }
      return agregar;
    });
  }

  buscarDesdeHasta() {
    this.loading.set(true);
    this.buscando = true;
    this.reinicioFechaInicioFechaFin();
    if (this.startDate < this.endDate) {
      this.getFacturasDevolucionLitros(this.startDate, this.endDate);
    }
    else {
      this.facturasFiltrados.splice(0, this.facturasFiltrados.length);
    }
    this.buscando = false;
  }

  reinicioFechaInicioFechaFin() {
    this.startDate = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    this.endDate = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
    this.endDate.setHours(23, 59, 59, 99);
  }

  solicitarRefacturacion(f) {
    const modalRef = this.modalService.open(ModalRefacturacionComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.facturaAnticipada = f;
    modalRef.componentInstance.tipoReporte = TipoReporteRefacturacion.Devolucion;
    modalRef.result.then(() => {
      this.ngOnInit();
    });
  }

  //Llamada al service
  getFacturasDevolucionLitros(fechaInicio: Date, fechaFin: Date){
    const desde: string = this.sharedService.formatDate(fechaInicio.getFullYear(), fechaInicio.getMonth() + 1, fechaInicio.getDate(), 0, 0);
    const hasta: string = this.sharedService.formatDate(fechaFin.getFullYear(), fechaFin.getMonth() + 1, fechaFin.getDate(), 23, 59);
    this.comprobanteService.getObtenerRecargasRefacturacion(desde, hasta)
      .subscribe(response => {
          this.facturas = response.sort((a,b) => { if (a.fechaHoraComprobante < b.fechaHoraComprobante) { return -1 } else { return 1 } });
          this.facturasFiltrados = response;
          this.loading.set(false);
        },
        () => {
          this.loading.set(false);
          this.facturas = [];
          this.facturasFiltrados = [];
        });
  }

  get busqueda() {
    return this.busquedaFormControl;
  }
}

